"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLicensePolicyAndCurriculums = exports.isPHDCurriculum = exports.hasEurekaMath = exports.hasWitAndWisdom = exports.hasWitAndWisdomOnly = exports.getCurriculumsFromProductLicenses = exports.getCurriculumAndProductFromLicenses = exports.getModulesFromGradeAndCurriculum = exports.getModulesFromGrades = exports.getGradesFromCurriculums = void 0;
var uniq_1 = __importDefault(require("lodash/uniq"));
var uniqBy_1 = __importDefault(require("lodash/uniqBy"));
var intersectionWith_1 = __importDefault(require("lodash/intersectionWith"));
var curriculum_model_1 = require("../models/curriculum/curriculum.model");
var constants_1 = require("../constants");
var curriculum_product_model_1 = require("../models/curriculum/curriculum-product.model");
/**
 * Return a list of unique grades from a list of curriculums
 */
var getGradesFromCurriculums = function (curriculums) {
    return (0, uniqBy_1.default)(curriculums.reduce(function (accum, curriculum) {
        accum = accum.concat(curriculum.grades);
        return accum;
    }, []), 'id');
};
exports.getGradesFromCurriculums = getGradesFromCurriculums;
/**
 * Return a list of unique modules from a list of grades
 */
var getModulesFromGrades = function (grades) {
    return (0, uniqBy_1.default)(grades.reduce(function (accum, grade) {
        accum = accum.concat(grade.modules);
        return accum;
    }, []), 'id');
};
exports.getModulesFromGrades = getModulesFromGrades;
/**
 * Returns a list of modules depending on the selected grade and curriculum
 */
var getModulesFromGradeAndCurriculum = function (curriculum, selectedGrade) { return curriculum[0].grades.filter(function (grade) { return grade.id === selectedGrade; })[0].modules; };
exports.getModulesFromGradeAndCurriculum = getModulesFromGradeAndCurriculum;
/*
 * Returns an array of Curriculum and products which are associated with the user
 */
var getCurriculumAndProductFromLicenses = function (licenses) {
    var curriculums = (0, uniq_1.default)(licenses.map(function (_a) {
        var curriculum = _a.curriculum;
        return curriculum.id;
    }));
    return curriculums.map(function (id) {
        var licencesByCurriculum = licenses.filter(function (_a) {
            var curriculum = _a.curriculum;
            return curriculum.id === id;
        });
        return new curriculum_product_model_1.CurriculumProduct({
            curriculum: id,
            productIds: (0, uniq_1.default)(licencesByCurriculum.map(function (license) { var _a; return (_a = license.product) === null || _a === void 0 ? void 0 : _a.id; })),
        });
    });
};
exports.getCurriculumAndProductFromLicenses = getCurriculumAndProductFromLicenses;
/**
 * Return a list of unique curriculums from a list of licenses
 */
var getCurriculumsFromProductLicenses = function (licenses, curriculums, productIds) {
    var licensesCurriculum = (0, uniq_1.default)(licenses.map(function (_a) {
        var curriculum = _a.curriculum, product = _a.product;
        return (productIds || []).includes(product === null || product === void 0 ? void 0 : product.id) && (curriculum === null || curriculum === void 0 ? void 0 : curriculum.id);
    }));
    return (0, intersectionWith_1.default)((0, uniqBy_1.default)(curriculums, 'id'), licensesCurriculum, function (curriculum, id) { return curriculum.id === id; });
};
exports.getCurriculumsFromProductLicenses = getCurriculumsFromProductLicenses;
/**
 * Indicates if a list of curriculums just have wit and wisdom
 */
var hasWitAndWisdomOnly = function (curriculums) {
    return curriculums.every(function (curriculum) { return curriculum.id.startsWith(constants_1.CurriculumId.WitAndWisdom); });
};
exports.hasWitAndWisdomOnly = hasWitAndWisdomOnly;
/**
 * Indicates if a list of curriculums have wit and wisdom
 */
var hasWitAndWisdom = function (curriculums) {
    return curriculums.some(function (_a) {
        var id = _a.id;
        return id.startsWith(constants_1.CurriculumId.WitAndWisdom);
    });
};
exports.hasWitAndWisdom = hasWitAndWisdom;
/**
 * Indicates if a list of curriculums have eureka math
 */
var hasEurekaMath = function (curriculums) {
    return curriculums.some(function (curriculum) { return curriculum.id.startsWith(constants_1.CurriculumId.EurekaMath); });
};
exports.hasEurekaMath = hasEurekaMath;
var isPHDCurriculum = function (curriculumId) {
    return curriculumId.startsWith(constants_1.CurriculumId.PhDScience);
};
exports.isPHDCurriculum = isPHDCurriculum;
var getLicensePolicyAndCurriculums = function (curriculums, licenseEntitlements) {
    var curriculumsFiltered = licenseEntitlements.reduce(function (licenses, license) {
        var policyId = license.id;
        var curriculum = curriculums.find(function (_a) {
            var licensePolicyId = _a.licensePolicyId;
            return licensePolicyId === policyId;
        });
        if (curriculum) {
            var addons = license.addOns.map(function (id) { return ({ licensePolicyId: id }); });
            licenses.push(new curriculum_model_1.Curriculum(__assign(__assign({}, curriculum), { licensePolicyId: policyId, addons: __spreadArray([], addons, true) })));
        }
        else
            console.log("License id not found ".concat(policyId));
        return licenses;
    }, []);
    return curriculumsFiltered;
};
exports.getLicensePolicyAndCurriculums = getLicensePolicyAndCurriculums;
